// This is generated.  Alter it in blockGroups/formElements/types/ElementGroups.js
/* eslint-disable no-unused-vars */
const { Type } = require('@sinclair/typebox');
const { merge } = require('lodash');
const { moduleRegistration } = require('@sstdev/lib_metadata-config');
module.exports = {
  asDataDictionary: function asDataDictionary(hNode, context) {
    const { id, title, propertyName, required } = hNode;
    // reuse consistent flags
    const { isOptional, schemaOptions } = moduleRegistration.resolveFieldFlags(
      required,
      context,
    );

    // Gather option schemas from children and merge their subDataDictionaries
    const optionBuilds =
      (hNode.children || []).map((child, index) => {
        const [childSubDD = {}, childPartialMap = {}] =
          context.extractFromChild(child, context) || [{}, {}];

        // Each option has an optional "id" (default to child.title) + whatever the child contributed
        // id is optional to allow payloads that use 'type' as the discriminator for anyOf matching
        const optionSchema = Type.Object(
          {
            id: Type.Optional(
              Type.String({
                title: 'id',
                'x-propertyName': 'id',
                'x-defaultValue': child.title,
                'x-optional': true,
                'x-editable': false,
              }),
            ),
            // childPartialMap is a plain object: prop -> TypeBox schema
            ...childPartialMap,
          },
          {
            title: String(index),
            // additionalProperties: true allows extending options with extra properties
            // This enables dynamic property addition beyond the defined schema
            additionalProperties: true,
          },
        );

        return { childSubDD, optionSchema };
      }) || [];

    // Merge all child sub dictionaries using reduce to accumulate all nested schemas
    const subDataDictionary =
      optionBuilds.reduce((acc, cur) => merge(acc, cur.childSubDD), {}) || {};

    // Build the value schema: Array of union of option objects (or generic object if no children)
    // Type.Union creates JSON Schema union type - validates against any of the provided schemas
    const optionSchemas = optionBuilds.map((o) => o.optionSchema);
    const arrayItems =
      optionSchemas.length > 0
        ? Type.Union(optionSchemas)
        : Type.Object({}, { additionalProperties: true });

    const baseArraySchema = Type.Array(arrayItems, {
      title,
      'x-id': id,
      'x-dataType': 'array',
      'x-propertyName': propertyName,
      ...schemaOptions,
    });

    // Type.Optional makes the entire array optional if the field is not required
    const valueSchema = isOptional
      ? Type.Optional(baseArraySchema)
      : baseArraySchema;

    // Return plain map for partialTypeDefinition - this defines the property schema
    // The key is the dynamic propertyName, value is the TypeBox schema
    const partialTypeDefinition = {
      [propertyName]: valueSchema,
    };

    return [subDataDictionary, partialTypeDefinition];
  },
};
moduleRegistration.registerHNodeType(
  'formElements',
  'ElementGroups',
  module.exports,
);
